import React, { useState } from 'react'
import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Button,
  Alert,
  AlertIcon,
  AlertDescription,
} from '@chakra-ui/react'
import { useAuth } from '../contexts/AuthContext'

interface LoginModalProps {
  isOpen: boolean
  onClose: () => void
}

const LoginModal = ({ isOpen, onClose }: LoginModalProps) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { login } = useAuth()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!email || !password) {
      setError('이메일과 비밀번호를 입력해주세요')
      return
    }

    setLoading(true)
    setError('')

    const result = await login(email, password)

    if (result.success) {
      onClose()
    } else {
      setError(result.error ?? '로그인에 실패했습니다')
    }

    setLoading(false)
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="blackAlpha.600" />
      <ModalContent mx={4} maxW="md">
        <ModalHeader fontSize="2xl" fontWeight="bold" color="gray.900">
          관리자 로그인
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={8}>
          <Box as="form" onSubmit={handleSubmit}>
            <FormControl mb={4} isRequired>
              <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
                이메일
              </FormLabel>
              <Input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@example.com"
                borderColor="gray.300"
                _focus={{
                  borderColor: 'blue.500',
                  boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)',
                }}
              />
            </FormControl>

            <FormControl mb={4} isRequired>
              <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
                비밀번호
              </FormLabel>
              <Input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="비밀번호를 입력하세요"
                borderColor="gray.300"
                _focus={{
                  borderColor: 'blue.500',
                  boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)',
                }}
              />
            </FormControl>

            {error && (
              <Alert status="error" borderRadius="md" mb={4}>
                <AlertIcon />
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}

            <Button
              type="submit"
              w="full"
              colorScheme="blue"
              isLoading={loading}
              loadingText="로그인 중..."
              _hover={{ bg: 'blue.700' }}
            >
              로그인
            </Button>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default LoginModal
